export function Page(props: {children: React.ReactNode}) {
    return (
        <div className="bg-light-surface dark:bg-tertiary-dark w-full relative h-screen flex flex-col overflow-hidden">
            {props.children}
        </div>
    )
}